import { cn } from "@/lib/utils";

interface ListCardProps {
    label: string;
    value: React.ReactNode;
    labelClass?: string;
    valueClass?: string;
    id: string;
    alignValueEnd?: boolean;
    compact?: boolean;
}

const ListCard: React.FC<ListCardProps> = ({
    label,
    value,
    labelClass,
    valueClass,
    id,
    alignValueEnd = false,
    compact = false,
}) => {
    return (
        <li
            className={cn(
                "flex items-center border-b border-muted px-5 last:border-b-0",
                compact ? "py-2.5 md:py-3" : "py-3 md:py-4"
            )}
        >
            <div className="flex w-full flex-col items-start md:flex-row md:items-center">
                <div
                    id={`${id}-label`}
                    className={cn(
                        "w-full shrink-0 text-[13px] leading-6 text-muted-foreground md:w-1/2",
                        labelClass
                    )}
                >
                    {label}
                </div>
                <div
                    id={`${id}-value`}
                    className={cn(
                        "min-w-0 w-full text-[15px] leading-6 text-foreground md:w-1/2 md:flex-1",
                        alignValueEnd && "md:flex md:items-center md:justify-end gs-detail-kv-value-end",
                        valueClass
                    )}
                >
                    {value}
                </div>
            </div>
        </li>
    );
};

export default ListCard;
